import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue';
var $t = Vue.prototype.$t;

// 节点类型
export var nodeI18n = new Map([[1, 'work_rule_23'], [2, 'cc-type'], [3, 'work_rule_59']]);

// 审批类型
export var approvalMap = [{
  key: 2,
  label: 'work_rule_56',
  type: [1, 2, 4]
}, {
  key: 4,
  label: 'work_rule_57',
  type: [1, 2, 4]
}, {
  key: 1,
  label: 'work_rule_58',
  type: [1, 2, 4]
}];

// 审批人全部离职
export var noLeaveOfficeData = [{
  key: 1,
  label: '173'
}, {
  key: 2,
  label: '970'
}, {
  key: 3,
  label: 'd134ea24'
}];

// 审批人为空选项
export var noHanderActionData = [{
  key: 1,
  label: '173'
}, {
  key: 2,
  label: '970'
}];

// 会签或签
export var manyPeopleApproval = [{
  key: 1,
  label: 'work_rule_46'
}, {
  key: 2,
  label: 'work_rule_47'
}];
var warn = new Map([[0, ''], [9, ''], [1, 'work_rule_41'], [3, 'work_rule_42']]);
// status false不展示提示
export var warning = function warning(nodeType) {
  return {
    status: false,
    msg: warn.get(nodeType) || ''
  };
};

/**
 * settype 审批人 1- 指定员工 2- 指定上级 4- 组织负责人
 * val对应的值
 * @returns { Object }
 */
export var formAuditor = function formAuditor() {
  return {
    settype: '',
    val: ''
  };
};
// 审批人模版
// isCC是否为抄送节点
// 抄送节点默认有一条抄送数据
export var approvalForm = function approvalForm(isCc) {
  var tem = {
    // 审批人
    auditor: [formAuditor()],
    // 审批人为空时指定审批人
    directorLevelPerson: [],
    // 抄送人
    cc: [],
    // 审批人为空
    noHanderAction: 1,
    resign_policy: 1,
    // 是否仅同意时抄送
    ccPolicy: true,
    // 会签或签
    node_audit_type: 1
  };
  if (isCc) tem.cc = [formAuditor()];
  return tem;
};

/**
 * nodeName: 节点名称,
 * nodeCode: 节点ID,
 * id: 节点ID
 * warning: 校验,
 * form: 节点数据,
 * childNode: 自节点
 * pkId: 节点类型ID
 * type: 节点类型
 */
export var sourceData = {
  nodeName: $t('73'),
  nodeCode: uuidv4(),
  id: uuidv4(),
  warning: warning(0),
  form: approvalForm(),
  childNode: {
    type: 1,
    nodeName: $t('work_rule_48'),
    nodeCode: uuidv4(),
    form: approvalForm(),
    warning: warning(1)
  },
  pkId: 'sid-start-node',
  type: 0,
  noHanderAction: ''
};

/**
 *  条件数据模版
 *  condition 条件名称
 *  operator 运算符
 *  value 值
 */
export var branchFormItem = function branchFormItem() {
  return {
    condition: '',
    operator: '',
    value: ''
  };
};

/**
 *  根据审批人Type动态组件
 *  1 指定人员 2 直线上级  4 组织负责人 3 下拉框  5 输入框
 */
export default new Map([[1, function () {
  return import('./components/select-person');
}], [2, function () {
  return import('./components/line-superior');
}], [4, function () {
  return import('./components/organization-person');
}], [3, function () {
  return import('./components/select');
}], [5, function () {
  return import('./components/f-input');
}]]);